export const FETCH_CANCELLATION = {
  CANCEL_QUERY_TRIGGER: 'Cancel the query trigger',
  CANCEL_ALL_REQUESTS: 'Cancel all requests',
  BY_DATAFLOW: 'Cancel triggered by Dataflow',
};

export const ROOT_LEVEL_GROUP_NAME = 'baseProperties';

export const MAX_TREE_HEIGHT = 300;
export const MAX_MULTI_ENTITY_LIST_HEIGHT = 400;

/** Fallback entry used before an entity's own expand/sortBy/visibleFields entry is computed. */
export const EMPTY_EXPAND_ENTRY = { value: [], options: [], optionsMap: {} };
export const EMPTY_SORT_BY_ENTRY = { value: [], options: [], flags: {} };
export const EMPTY_VISIBLE_FIELDS_ENTRY = { value: [], options: [], optionsMap: {} };
export const NO_FOLDED_GROUPS = {};

export const PAGE_SIZE = 100;

export const FETCH_STATE = {
  IDLE: 'IDLE',
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
};

export const QUERY_STATE = {
  IDLE: 'IDLE',
  QUERYING: 'QUERYING',
  QUERY_SUCCESSFUL: 'QUERY_SUCCESSFUL',
  QUERY_FAILED: 'FAILED',
  RESET: 'RESET',
};

export const EDIT_RUN_STATUS = {
  STARTED: 'started',
  VALIDATION: 'validation',
  DATA_FILE_ERROR: 'data_file_error',
  GENERATION_REQUEST_REJECTED: 'generation_request_rejected',
  GENERATION_APPROVAL_PENDING: 'generation_approval_pending',
  GENERATION: 'generation',
  COMPLETED: 'completed',
  FAILED: 'failed',
  COMPLETED_WITH_ERRORS: 'completed_with_errors',
  ABORTED: 'aborted',
};

export const ERROR_TYPES = {
  INVALID_REQUEST_ERROR: 'internal_request_error',
  SYSTEM_NOT_CONFIGURED: 'user_system_not_configured',
  COMMON_ERRORS: 'COE',
  AUTHENTICATION_ERROR: 'authentication_error',
  VALIDATION_ERROR: 'validation_error',
};

export const LOG_TYPE = {
  QUERY_VIEW: 'QUERY_VIEW',
  REPORT_VIEW: 'REPORT_VIEW',
};

export const BOOKMARK_TYPE = {
  QUERY_VIEW: 'QUERY_VIEW',
  REPORT_VIEW: 'REPORT_VIEW',
};

export const JOB_STATE = {
  WAITING: 'waiting',
  STARTED: 'started',
  COMPLETED: 'completed',
  FAILED: 'failed',
  ABORTED: 'aborted',
  QUEUED: 'queued',
};

export const EXPORT_JOB_STEPS = [
  'Configure Metadata',
  'Configure Picklist',
  'Customize Sheet Name',
  'Password Protection',
];

export const SYSTEM_CONFIG_STEPS = ['Configure Metadata', 'Configure Picklist'];

export const SYSTEMS = {
  SF_EC: {
    KEY: 'SF_EC',
    LABEL: 'SuccessFactors Employee Central',
  },
  ODATA_SERVICE: {
    KEY: 'ODATA_SERVICE',
    LABEL: 'OData Service',
  },
  SF_EC_SHARED: {
    KEY: 'SF_EC_SHARED',
    LABEL: 'Demo SuccessFactors Employee Central',
  },
  ODATA_SERVICE_SHARED: {
    KEY: 'ODATA_SERVICE_SHARED',
    LABEL: 'Demo OData Service',
  },
};

export const STEPPER_FLOWS = {
  SYSTEM_CONFIGURATION: {
    KEY: 'SYSTEM_CONFIGURATION',
    STEPS: ['Configure Metadata', 'Configure Picklist'],
  },
};

export const COE_DOCUMENTATION =
  'https://help.sap.com/docs/SAP_SUCCESSFACTORS_PLATFORM/d599f15995d348a1b45ba5603e2aba9b/136931f720dd4b588ceccb422927f041.html?locale=en-US&q=COE';

export const LOOKUP_TYPES = {
  PICKLIST: 'picklist',
  FOUNDATION_OBJECT: 'foundation-object',
};

export const LOOKUP_TYPE_TABLE_COLUMNS = {
  [LOOKUP_TYPES.PICKLIST]: [
    { key: 'checkbox', label: '' },
    { key: 'label', label: 'Label' },
    { key: 'externalCode', label: 'External Code' },
    { key: 'optionId', label: 'Option ID' },
  ],
  [LOOKUP_TYPES.FOUNDATION_OBJECT]: [
    { key: 'checkbox', label: '' },
    { key: 'name', label: 'Name' },
    { key: 'externalCode', label: 'External Code' },
  ],
};

export const SHEET_NAMING_CONVENTION = {
  TECHNICAL: { value: 'entity_code', label: 'Technical (MDGen Compatible)' },
  USER_FRIENDLY: { value: 'entity_name', label: 'User friendly' },
};

export const DOM_IDS = {
  JOBS_PANEL: 'INTEGRTR__JOBS_PANEL',
  JOBS_HEADER: 'INTERGTR__JOBS_HEADER',
  TABS_PANEL: 'INTEGRTR__TABS_PANEL',
  REPORT_VIEW_DRAWER: 'INTEGRTR__REPORT_VIEW_DRAWER',
  COLLECTION_FIELDS: {
    NAME: 'INTEGRTR__COLLECTION_NAME_FIELD',
    DESCRIPTION: 'INTEGRTR__COLLECTION_DESC_FIELD',
  },
  EXPORT_PREFERENCES_HELP_BTN: 'INTEGRTR__EXPORT_PREFERENCES_HELP_BTN',
  QUERY_PREFERENCES_HELP_BTN: 'INTEGRTR__QUERY_PREFERENCES_HELP_BTN',
};

export const BOOKMARK_ACTION_TYPES = {
  CREATE: 'CREATE',
  UPDATE_EXISTING: 'UPDATE_EXISTING',
};

export const BOOKMARKS_TABLE_HEADERS = [
  { label: 'Collection', pl: 13 },
  { label: 'Bookmark', pl: 14 },
  { label: 'Description', pl: 14 },
  { label: 'View Query', pl: 20 },
];

// Known paths where COE errors appear
export const COE_PATHS = [
  'errorDetails.errorDetails.error', // Most deeply nested (double errorDetails)
  'errorDetails.error', // One level less nested
  'error', // Direct error property
];

/** Known paths for human-readable system error messages (e.g. SF OData errors). */
export const SYSTEM_ERROR_MESSAGE_PATHS = [
  'errorDetails.errorDetails.error.message.value',
  'errorDetails.error.message.value',
  'error.message.value',
  'errorDetails.errorObject.message',
  'errorObject.message',
];

export const IN_OPERATOR_MAX_PARAMS = 1000;

export const DRAWER_TAB_INDEX = {
  AI_CHAT: 0,
  BOOKMARKS: 1,
  QUERY_LOGS: 2,
  JOBS: 3,
};

export const DRAWER_TAB_INDEX_WITHOUT_AI = {
  BOOKMARKS: 0,
  QUERY_LOGS: 1,
  JOBS: 2,
};

export const AI_MODEL_TYPES = {
  FAST: 'fast',
  INTELLIGENT: 'intelligent',
};

export const AI_SSE_EVENT_TYPE = {
  REASONING_DELTA: 'reasoning_delta',
  TEXT_DELTA: 'text_delta',
  TOOL_RESULT: 'tool_result',
  DONE: 'done',
  ERROR: 'error',
};

export const AI_FINISH_REASON = {
  TOKEN_LIMIT_EXCEEDED: 'token_limit_exceeded',
};

export const AI_MESSAGE_PART_TYPE = {
  TEXT: 'text',
  REASONING: 'reasoning',
  TOOL_CALL: 'tool_call',
  TOOL_RESULT: 'tool_result',
};

export const AI_MESSAGE_ROLE = {
  USER: 'user',
  ASSISTANT: 'assistant',
};

export const AI_VIEW_MODE = {
  WELCOME: 'welcome',
  CHAT: 'chat',
  HISTORY: 'history',
};

export const AI_TEXT_SEGMENT_TYPE = {
  TEXT: 'text',
  QUERY: 'query',
};

export const AI_FEEDBACK_TYPE = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
};

/*
 * Query-shape params sent to the AI assistant. Excludes pagination, transport,
 * and baseParams (noise / auth). Order matters: emitted in this array's order.
 */
export const AI_EDITOR_QUERY_PARAM_KEYS = [
  '$select',
  '$filter',
  '$expand',
  '$orderby',
  'asOfDate',
  'fromDate',
  'toDate',
  'balanceAsOf',
];

export const AI_SUGGESTED_PROMPTS = [
  {
    icon: 'person',
    text: 'Get all active employees with their basic details',
  },
  {
    icon: 'filter_list',
    text: 'Find employees who joined after January 2024',
  },
  {
    icon: 'business',
    text: 'List all departments with their details',
  },
  {
    icon: 'search',
    text: 'Search for employees by country of birth',
  },
];

// --- Table view grid ---

export const ROOT_HEADER_GROUP_KEY = '__root__';
export const ROOT_ROW_VIEW_GROUP_KEY = '__root__';
export const ROW_VIEW_COLUMN_WIDTH = 38;
export const VIEW_DETAILS_COLUMN_KEY = '_INT_VIEW_DETAILS';
export const MAX_NAV_DEPTH = 5;
export const NAV_TIER_HEADER_BAND_HEIGHT = 28;
export const FIELD_HEADER_BAND_MIN_HEIGHT = 56;
export const TABLE_TIME_NAV_FETCH_TOP = 25;
export const UI_ONLY_KEY_PREFIXES = ['_INT_'];
export const SHOW_ALL_FIELDS_SELECT_CHUNK_SIZE = 20;

// --- View Details dialog ---

export const NESTED_EXPAND_DISPLAY_LIMIT = 25;
export const EXPAND_BUTTON_SIZE_PX = 24;
export const EXPAND_BUTTON_ICON_SIZE_PX = 14;
export const NESTED_EXPAND_SKELETON_ROW_COUNT = 2;
export const NESTED_EXPAND_SKELETON_MAX_COLUMNS = 12;

// --- Bookmark panel ---

// Placeholder height for a bookmark row before its real height is measured.
export const BOOKMARK_ESTIMATED_HEIGHT = 110;

// Tallest a collection's bookmark list gets before it scrolls, unless it is the last collection.
export const BOOKMARK_LIST_MAX_HEIGHT = 400;

export const LINKED_QUERY_UNAVAILABLE_TEXT = 'This query could not be prepared for saving';

// --- Filter option layout ---

export const FILTER_FIELD_WIDTH = '220px';

// --- Linked By option layout ---

export const LINKED_BY_COLUMN_WIDTH = 210;
export const LINKED_BY_SEPARATOR_WIDTH = 24;
export const LINKED_BY_REMOVE_BUTTON_WIDTH = 40;

// --- Expand option ---

export const EXPAND_ROW_KIND = {
  ENTITY: 'entity',
  GROUP: 'group',
  PROPERTY: 'property',
};

// Placeholder heights for a row before its real height is measured, keyed by EXPAND_ROW_KIND.
export const ESTIMATED_EXPAND_ROW_HEIGHTS = {
  [EXPAND_ROW_KIND.ENTITY]: 46,
  [EXPAND_ROW_KIND.GROUP]: 40,
  [EXPAND_ROW_KIND.PROPERTY]: 32,
};
